module.exports = __webpack_public_path__ + "assets/d04eeeec8505e2ae4b398c849e7f2e7d.png";